import {TestsContentWrapper, TestsPageWrapper} from '@pages/TestsPage.styles';
import PageTitleBlock from '@organisms/PageTitleBlock';
import Button from '@atoms/Button';
import {AddAlt, ExamMode} from '@carbon/icons-react';
import PageSubtitleBlock from '@organisms/PageSubtitleBlock';
import PageSubtitleTextBlock from '@molecules/PageSubtitleTextBlock';
import {theme} from '@styles/theme';
import {useEffect, useState} from 'react';
import {
  PageSubtitleLegendMark,
  PageSubtitleLegendWrapper,
} from '@organisms/PageSubtitleBlock.styles';
import Text from '@atoms/Text';
import {useDispatch, useSelector} from 'react-redux';
import {getTestsFull, tests} from '@store/slices/tests';
import {ITest} from '@types';
import AddTestModal from '@organisms/modals/AddTestModal';
import EmptyBlock from '@molecules/EmptyBlock';
import TestsTable from '@organisms/TestsTable';
import CircleButton from '@atoms/CircleButton';
import {AppDispatch, RootState} from '@store';
import {IDLE, PENDING} from '@constants/loadingState';
import DeleteTestModal from '@organisms/modals/DeleteTestModal';
import {formatLastUpdate} from '@utils/common';

export const TestsPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {loading, addTestLoading, deleteTestLoading} = useSelector(
    (state: RootState) => state.tests,
  );
  const testsArr: ITest[] = useSelector(tests);
  const [selectedTestsIds, setSelectedTestsIds] = useState<number[]>([]);
  const [testsOnDelete, setTestsOnDelete] = useState<number[]>([]);
  const [testOnEdit, setTestOnEdit] = useState<ITest | undefined>();
  const [addTestShow, setAddTestShow] = useState(false);
  const [deleteTestShow, setDeleteTestShow] = useState(false);

  useEffect(() => {
    dispatch(getTestsFull({}));
  }, []);

  useEffect(() => {
    if (addTestLoading === IDLE && deleteTestLoading === IDLE) {
      dispatch(getTestsFull({}));
    }
  }, [addTestLoading, deleteTestLoading]);

  return (
    <TestsPageWrapper>
      <PageTitleBlock
        title="Виды тестов"
        buttons={[
          <Button
            key={'add-system-title'}
            title="Добавить тест"
            iconElement={<AddAlt />}
            variant="filled"
            onClick={() => setAddTestShow(true)}
          />,
          <CircleButton
            key={'delete-test-title'}
            menu={[
              {
                title: `Удалить (${selectedTestsIds.length})`,
                onClick: () => {
                  if (selectedTestsIds.length) {
                    setTestsOnDelete(
                      selectedTestsIds.map(id => {
                        return Number(id);
                      }),
                    );
                    setDeleteTestShow(true);
                  }
                },
                color: selectedTestsIds.length
                  ? theme.colors.signalRed00
                  : theme.colors.basic04,
              },
            ]}
          />,
        ]}
      />
      <PageSubtitleBlock
        elementsToLeft={[
          <PageSubtitleTextBlock
            title="Всего тестов:"
            text={`${testsArr.length}`}
            key="all-tests-count"
          />,
          <PageSubtitleTextBlock
            title="Последнее изменение"
            text={`${formatLastUpdate(testsArr[0]?.last_active || '')} `}
            key="tests-last-activity"
          />,
        ]}
        elementsToRight={[
          <PageSubtitleLegendWrapper key="manual-legend">
            <PageSubtitleLegendMark color={theme.colors.manual00} />
            <Text text="Ручные" type="tinyR" color={theme.colors.basic02} />
            <Text text="54,67%" type="tinyNum" color={theme.colors.basic02} />
          </PageSubtitleLegendWrapper>,
          <PageSubtitleLegendWrapper key="auto-legend">
            <PageSubtitleLegendMark color={theme.colors.auto00} />
            <Text text="Автоматизировано" type="tinyR" color={theme.colors.basic02} />
            <Text text="45,43%" type="tinyNum" color={theme.colors.basic02} />
          </PageSubtitleLegendWrapper>,
        ]}
      />
      <TestsContentWrapper>
        {((!!testsArr.length && loading === IDLE) || loading === PENDING) && (
          <TestsTable
            tests={testsArr}
            loading={loading}
            onSort={() => {}}
            onDelete={test_id => {
              setTestsOnDelete([test_id]);
              setDeleteTestShow(true);
            }}
            onEdit={test_id => {
              setTestOnEdit(
                testsArr.find(test => {
                  return test.id === test_id;
                }),
              );
              setAddTestShow(true);
            }}
            onSelectRow={setSelectedTestsIds}
          />
        )}
        {!testsArr.length && loading === IDLE && (
          <EmptyBlock
            icon={<ExamMode size={32} color={theme.colors.accent00} />}
            text="Здесь пусто. Добавьте пользователей и редакторов для администрирования состояния тестового покрытия."
          />
        )}
      </TestsContentWrapper>
      <AddTestModal
        isOpened={addTestShow}
        onCloseRequest={() => {
          setAddTestShow(false);
          setTestOnEdit(undefined);
        }}
        test={testOnEdit}
      />
      <DeleteTestModal
        isOpened={deleteTestShow}
        testsIds={testsOnDelete}
        onCloseRequest={() => setDeleteTestShow(false)}
      />
    </TestsPageWrapper>
  );
};

export default TestsPage;
